export default "__VITE_ASSET__weGC$Njp__"